import moment from 'moment';
import { environment } from '../environments/environment';
import { ActiveFilter } from './shared/enums/active-filter.enum';

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-DD hh:mm:ss';

export class FrontendSettings {
  public static VIEWS: any = [
    {
      name: 'Entities',
      path: 'entity',
      icon: 'linode'
    },
    {
      name: 'Dashboard',
      path: 'dashboard',
      icon: 'tachometer'
    },
    {
      name: 'Static',
      path: 'static',
      icon: 'gavel'
    },
    {
      name: 'Match',
      path: 'match',
      icon: 'plug'
    },
    {
      name: 'Powers',
      path: 'powers',
      icon: 'hand-rock-o'
    },
    {
      name: 'Calendar',
      path: 'calendar',
      icon: 'calendar'
    },
    {
      name: 'Universes and Tiers',
      path: 'company_institution_lists',
      icon: 'list-ul'
    },
    {
      name: 'Task Manager',
      path: 'task_manager',
      icon: 'list-ul'
    },
    {
      name: 'Document processing',
      path: 'doc_process',
      icon: 'file'
    },
    {
      name: 'Missing Calendar Events',
      path: 'missing-events',
      icon: 'calendar-minus-o'
    },
    {
      name: 'Market cap',
      path: 'marketcap',
      icon: 'pie-chart'
    },
    {
      name: 'Shareholders',
      path: 'shareholders',
      icon: 'group'
    },
    {
      name: 'Company Reports',
      path: 'company_reports',
      icon: 'paperclip'
    },
    {
      name: 'Mozenda',
      path: 'mozenda',
      icon: 'medium'
    },
    {
      name: 'Estimates',
      path: 'estimates',
      icon: 'line-chart'
    },
    {
      name: 'Press Release',
      path: 'press_release',
      icon: 'book'
    },
    {
      name: 'News Desk Tier',
      path: 'news-desk-tier',
      icon: 'graduation-cap'
    }
  ];
}

export class ApiSettings {
  public static DOMAIN: string = environment.domain;
  public static API_HOST: string = environment.api_host;
  public static BASE_URL: string = ApiSettings.API_HOST + '/api';
  public static HORIZON_URL: string = ApiSettings.API_HOST + '/horizon';

  public static META_ENDPOINT = 'meta';
  public static HISTORY_ENDPOINT = 'history';
  public static AUTH_ENDPOINT = 'auth';
  public static ME_ENDPOINT = 'me';
  public static FILE_ENDPOINT = 'file';
  public static FILE_TOKEN_ENDPOINT = 'filetoken';
  public static USERS_ENDPOINT = 'all_users';
  public static BATCH_LOG_ENDPOINT = 'batch_logs';
  public static TEMPORARY_STORAGE = 'temporary_storage';
  public static WEBHOOK_CUSTOMERS_ENDPOINT = 'powers_customer';

  public static RELATION_ADD = 'attach';
  public static RELATION_REMOVE = 'detach';
  public static INCLUDE_ALL = 'include_all_companies';
  public static INCLUDE_ALL_INSTITUTIONS = 'include_all_institutions';
  public static INTERNAL_SERVER_ERROR = 'Something went wrong. Please contact the administrator.';

  public static RESPONSES: any = {
    VALUE_ERROR: 'VALUE_ERROR',
    ENTITY_OUTDATED: 'ENTITY_OUTDATED',
    PERMISSION_ERROR: 'PERMISSION_ERROR',
    ENTITY_HAS_DEPENDENT_ENTITIES: 'HAS_DEPENDENT_ENTITIES',
    TOKEN_EXPIRED: 'token_expired',
    TOKEN_EXPIRED_MESSAGE: 'Token has expired',
    TOKEN_NOT_PROVIDED: 'token_not_provided',
    TOKEN_NOT_PROVIDED_MESSAGE: 'Token not provided',
    TOKEN_INVALID: 'token_invalid',
    TOKEN_INVALID_MESSAGE: 'Malformed token'
  };

  public static RESPONSE_CODES: any = {
    PERMISSION_ERROR: 403,
    NOT_FOUND: 404,
  };

  public static POWERS: any = [
    {
      name: 'Create indexes',
      endpoint: 'create_indexes',
      method: 'POST'
    },
    {
      name: 'Generate permissions',
      endpoint: 'permission/generate',
      method: 'GET'
    },
    {
      name: 'Update currencies',
      endpoint: 'currency/update',
      method: 'GET'
    },
    {
      name: 'Update geography',
      endpoint: 'country/update',
      method: 'GET'
    },
    {
      name: 'Update languages',
      endpoint: 'language/update',
      method: 'GET'
    },
    {
      name: 'Update exchanges',
      endpoint: 'exchange/update',
      method: 'GET'
    },
    {
      name: 'Update sectors',
      endpoint: 'sector/update',
      method: 'GET'
    },
    {
      name: 'Update instruments',
      endpoint: 'instrument/update',
      method: 'GET'
    },
    {
      name: 'Import Infront Feeds',
      endpoint: 'infront_feed/import',
      method: 'GET'
    },
    {
      name: 'Sync Infront Feeds/Instruments',
      endpoint: 'infront_feed/sync_instruments',
      method: 'GET'
    },
    {
      name: 'Import companies',
      endpoint: 'company/import',
      method: 'GET'
    },
    {
      name: 'Match companies',
      endpoint: 'company/match',
      method: 'GET'
    },
    {
      name: 'Import Number of Shares',
      endpoint: 'share_count/import',
      method: 'GET'
    },
    {
      name: 'Import descriptions',
      endpoint: 'description/import',
      method: 'POST'
    },
    {
      name: 'Update Infront sectors',
      endpoint: 'infront_sector/update',
      method: 'GET'
    },
    {
      name: 'Add quantities',
      endpoint: 'quantity/update_quantities',
      method: 'POST'
    },
    {
      name: 'Add Units',
      endpoint: 'unit/update_units',
      method: 'POST'
    },
    {
      name: 'Sync company universes',
      endpoint: 'company_universe/sync',
      method: 'POST'
    },
    {
      name: 'Sync direkt calendar events',
      endpoint: 'calendar_event/sync_direkt',
      method: 'POST'
    },
    {
      name: 'Create tasks for static data',
      endpoint: 'static/create_tasks',
      method: 'GET'
    },
    {
      name: 'Create tasks for instruments',
      endpoint: 'instrument/create_tasks',
      method: 'GET'
    },
    {
      name: 'Create tasks for calendar',
      endpoint: 'company/create_tasks',
      method: 'GET'
    },
    {
      name: 'Create tasks for company tiers',
      endpoint: 'company_tier/create_tasks',
      method: 'GET'
    },
    {
      name: 'Create tasks for institution tiers',
      endpoint: 'institution_tier/create_tasks',
      method: 'GET'
    },
    {
      name: 'Import Instruments CSV',
      endpoint: 'instrument/import_instruments_csv',
      method: 'GET'
    },
    {
      name: 'Create tasks for Shareholder data',
      endpoint: 'shareholder/create_tasks',
      method: 'GET'
    },
    {
      name: 'Update Taxonomies',
      endpoint: 'company_report/update_taxonomies',
      method: 'GET'
    },
    {
      name: 'Update CIK codes',
      endpoint: 'company/update_cik_code',
      method: 'GET'
    }
  ];
  public static ENTITIES_WITH_IS_ACTIVE_FILTER: any = [ActiveFilter.DirektProfile]
  public static CUSTOM_ENTITY_API_URLS: any = {
    survey: 'estimates/survey/create'
  }
  public static ENTITY_LIST_CUSTOM_ORDER: any = {
    ReportPeriod: { orderField: 'name', order: ['H1', 'H2', 'Annual', 'Q1', 'Q2', 'Q3', 'Q4'] }
  }
}

export class MatchSettings {
  public static BASE_URL: string = ApiSettings.BASE_URL + '/instrument';
  public static COUNTS_ENDPOINT = 'counts';
  public static UNMATCHED_ENDPOINT = 'unmatched';
  public static MATCH_ENDPOINT = 'match';
  public static MARK_AS_INACTIVE_ENDPOINT = 'inactive';
  public static INCONSISTENT_ENDPOINT = 'inconsistent';
}

export class StaticSettings {
  public static TIER_ID = environment.company_static_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/static';
  public static COUNTS_ENDPOINT = 'counts';
  public static MISSING_ENDPOINT = 'missing';
  public static REVISIONS_ENDPOINT = 'revisions';
  public static APPROVE_ENDPOINT = 'approve';
  public static COMPANY_ENDPOINT = 'company';
  public static MISSING_DONE_ENDPOINT = 'created';
  public static REQUIRED_COMPANY_POSITIONS: any = ['CEO', 'Chairman'];
  public static POSITIONS_ENDPOINT = 'positions';
  public static ADVISORS_ENDPOINT = 'advisors';
  public static DESCRIPTIONS_ENDPOINT = 'description';
  public static COMPANY_DATA_ENDPOINT = 'company_data';
  public static SECTOR_ENDPOINT = 'sectors';
}

export class ShareholderSettings {
  public static TIER_ID = environment.company_shareholders_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/shareholder';
  public static COUNTS_ENDPOINT = 'counts';
  public static MISSING_ENDPOINT = 'missing';
  public static REVISIONS_ENDPOINT = 'outdated';
  public static COMPANY_ENDPOINT = 'company';
}
export class MissingCompanyEventsSettings {
  public static TIER_ID = environment.company_calendar_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/company';
  public static COUNTS_ENDPOINT = 'missing_events_count';
  public static MISSING_ENDPOINT = 'missing_events';
  public static COMPANY_ENDPOINT = 'missing_events';
  public static MISSING_DONE_ENDPOINT = 'created';
  public static EARNINGS_EVENT_TYPE = 'Earnings';
  public static MISSING_EVENTS_DEFAULT_FROM_DATE = moment().startOf('day')
  public static MISSING_EVENTS_DEFAULT_TO_DATE = moment().add(3, 'months').endOf('day')
}

export class MissingInstitutionEventsSettings {
  public static TIER_ID = environment.institution_calendar_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/institution';
  public static COUNTS_ENDPOINT = 'counts';
  public static MISSING_ENDPOINT = 'missing_events';
  public static COMPANY_ENDPOINT = 'missing_events';
  public static MISSING_DONE_ENDPOINT = 'created';
}

export class CalendarSettings {
  public static TIER_ID = environment.company_calendar_tier;
  public static INSTITUITION_TIER_ID = environment.institution_calendar_tier;
  public static MISSING_ENDPOINT = 'missing_events';
  public static MISSING_FIXED_ENDPOINT = 'missing_events_fixed';
  public static CONFIRM_ENDPOINT = 'confirm_events';
  public static CONFIRM_FIXED_ENDPOINT = 'confirm_events_fixed';
  public static HISTORICAL_CONFIRM_FIXED_ENDPOINT =
    'historical_confirm_fixed_events';
  public static CRAWLED_EVENTS_PER_PAGE_SIZE = 25;
}

export class MarketcapSettings {
  public static TIER_ID = environment.company_marketcap_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/share_count';
  public static COUNTS_ENDPOINT = 'counts';
  public static COMPANY_ENDPOINT = 'company';
  public static MISSING_ENDPOINT = 'missing';
  public static OUTDATED_ENDPOINT = 'outdated';
  public static DUPLICATE_PRIMARIES_ENDPOINT = 'duplicate_primaries';
  public static MISSING_PRIMARIES_ENDPOINT = 'missing_primaries';
}

export class MozendaDeliveriesSettings {
  public static BASE_URL: string = ApiSettings.BASE_URL + '/mozenda';
  public static COUNTS_ENDPOINT = 'counts';
  public static DELIVERIES_ENDPOINT = 'deliveries';
  public static PRODUCTION_ENDPOINT = 'production';
}

export class ListsSettings {
  public static TIER_MISSING_COMPANIES_ENDPOINT = 'missing_companies';
  public static TIER_MISSING_INSTITUTIONS_ENDPOINT = 'missing_institutions';
  public static TIER_ADDITIONAL_COMPANIES_ENDPOINT =
    'additional_companies';
  public static TIER_ADDITIONAL_INSTITUTIONS_ENDPOINT =
    'additional_institutions';
  public static UNIVERSE_SYNC_COMPANIES_ENDPOINT = 'sync';
  public static ASSIGN_MANAGER_TO_MISSING_COMPANIES_ENDPOINT =
    'assign_manager';
}
export class CompanyReportsSettings {
  public static TIER_ID = environment.company_report_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/company_report';
  public static COMPANY_ENDPOINT = 'company';
  public static MISSING_REPORTS_ENDPOINT =  CompanyReportsSettings.BASE_URL + '/missing_reports';
  public static MISSING_EVENTS_ENDPOINT =  CompanyReportsSettings.BASE_URL + '/missing_events';
  public static KEY_FINANCIAL_ENDPOINT = CompanyReportsSettings.BASE_URL + '/key_financials';
  public static MASK: any = {
    mask: Number,
    thousandsSeparator: ' ',
    scale: 7,
    radix: '.',
    mapToRadix: [','],
    min: -999999999999999,
  };

}
export class AuthSettings {
  public static WHITELISTED_DOMAINS: any = [ApiSettings.DOMAIN];
  public static BLACKLISTED_ROUTES: any = [
    ApiSettings.BASE_URL + '/' + ApiSettings.AUTH_ENDPOINT
  ];

  public static HEADER_NAME = 'Authorization';
  public static HEADER_PREFIX = 'Bearer ';
  public static TOKEN_NAME = 'token';
  public static SUPER_USER_ROLE = 'superuser';
  public static REFRESH_TOKEN_ENDPOINT = 'refresh_token';
  public static REDIRECT_KEY = 'RedirectUrl';

  public static getToken() {
    return localStorage.getItem(AuthSettings.TOKEN_NAME);
  }

  public static setToken(token: string) {
    localStorage.setItem(AuthSettings.TOKEN_NAME, token);
  }

  public static emptyToken() {
    localStorage.removeItem(AuthSettings.TOKEN_NAME);
  }
}
export class AutomatedContentSettings {
  public static BASE_URL = environment.api_host+ '/api/az/';

  public static MOZENDA_URL_PRODUCTION_EUR = AutomatedContentSettings.BASE_URL + 'infront-mozenda-dep-prod-eu/connector?';
  public static MOZENDA_URL_PRODUCTION_USA =  AutomatedContentSettings.BASE_URL + 'mozendadepprod2/connector?';
  public static MOZENDA_URL_STAGE =  AutomatedContentSettings.BASE_URL + 'mozendadep/connector?';
  public static MOZENDA_URL_LOCAL = 'http://localhost:7071/api/connector?';

  public static DOC_PROCESSING_URL_DEV = AutomatedContentSettings.BASE_URL + 'infront-doc-processing-dev/connector?';
  public static DOC_PROCESSING_URL_TEST = AutomatedContentSettings.BASE_URL + 'infront-doc-processing-test/connector?';
  public static DOC_PROCESSING_URL_PREVIEW = AutomatedContentSettings.BASE_URL + 'infront-doc-processing-preview/connector?';
  public static DOC_PROCESSING_URL_LABELING =  AutomatedContentSettings.BASE_URL + 'infront-doc-processing-labeling/connector?';
  public static DOC_PROCESSING_URL_PRODUCTION =  AutomatedContentSettings.BASE_URL + 'infront-doc-processing-prod3/connector?';
}
export class TranslationSettings {
  public static TRANSLATION_ENDPOINT = 'description/translate'
  public static LANGUAGE_LIST_ENDPOINT = 'language/translate_languages'
  public static COMPANY_ENDPOINT = 'company';
  public static SAVE_ALL = 'description/store_all';
  public static DESCRIPTIONS_ENDPOINT = 'description';
}

export class EstimatesSettings {
  public static TIER_ID = environment.estimates_tier;
  public static BASE_URL: string = ApiSettings.BASE_URL + '/estimates';
  public static FIXED_TAXONOMY_OPTIONS = [
    {name: 'Standard', id: 'std', is_fixed: true, taxonomy_type: 'Estimates'},
    {name: 'Standard Bank', id: 'std-bank', is_fixed: true, taxonomy_type: 'Estimates'},
    {name: 'Standard Real Estate', id: 'std-real-est', is_fixed: true, taxonomy_type: 'Estimates'}
  ]
  public static SURVEY_END_FIELD_COMMON_CONFIG = {
    type: "day",
    disabled: false,
    show_in_table: false,
    show_in_store: true,
    show_in_update: true,
    rules: []
  }
  public static SURVEY_STARTING_ANNUAL_END_FIELD_CONFIG = {
    ...this.SURVEY_END_FIELD_COMMON_CONFIG,
    key: "starting_annual_end",
    label: "Starting Annual End",
    field_index: 7
  }
  public static SURVEY_STARTING_QUARTER_END_FIELD_CONFIG = {
    ...this.SURVEY_END_FIELD_COMMON_CONFIG,
    key: "starting_quarter_end",
    label: "Starting Quarter End",
    field_index: 4
  }
  public static TAXONOMY_NAME_FIELD_CONFIG = {
    type: "string",
    is_primary: true,
    disabled: false,
    show_in_store: true,
    show_in_update: true,
    key: "taxonomy_name",
    label: "Taxonomy name",
    rules: ["string"],
  }
  public static TAXONOMY_NAME_GENERATION_CONFIG = {
    format: '{company_name} - {starting_quarter}',
  }
  public static VALUE_FORMAT_EXTRACT_PARTTERN = /{(.*?)}/g
  public static SURVEY_ENTITY_KEY = 'Survey'
  public static CONSENSUS_TYPE_OPTIONS = [
    { id: "PRE", name: "PRE" },
    { id: "POST", name: "POST" }
  ]
  public static DECIMAL_REGEX = /^\d*\.?\d+$/;
  public static DECIMAL_WITH_NEGATIVE_REGEX = /^-?\d*\.?\d+$/;
  public static INTEGER_REGEX = /^\d+$/;
  public static VALUE_MASK: any = {
    mask: Number,
    signed: true,
    thousandsSeparator: '',
    radix: '.',           
    scale: 20,            
    normalizeZeros: true
  };
  public static DERIVED_MODULES_DEFAULT_TYPE = 'KpiModule'
  public static IPT_MODULES: { type: string, name: string }[] = [
    { type: 'sales', name: 'Sales' },
    { type: 'ebit', name: 'EBIT' },
    { type: 'pretax_profit', name: 'Pretax profit' },
    { type: 'eps', name: 'EPS' },
    { type: 'dps', name: 'DPS' }
  ]
}

export class PressReleaseAttachmentSettings {
  public static MAX_FILE_SIZE = 102400; //100 MB, used as a backup option in case of missing rules from the backend
  public static VALID_EXTENSIONS = ['pdf', 'zip', 'html', 'xml', 'xlsx', 'json', 'jpeg', 'png']; //Used as a backup option in case of missing rules from the backend
  public static INVALID_SIZE_ERROR_KEY = 'INVALID_SIZE';
  public static INVALID_EXTENSION_ERROR_KEY = 'INVALID_EXTENSION';
}

export interface CalendarDefaultConfigItem {
  relationName: string;
  foreignKey: string;
  value: { id: number; [key: string]: unknown };
}

export class CalendarEventSettings {
  public static CALENDAR_EVENT_PREFILL_DATA = {
    date_confirmed: true,
    date_approximation_id: environment.date_approx_object.id,
    time_approximation_id: environment.time_approx_object.id,
    to_date: null,
    source_type: environment.calendar_event_default_source_type
  };
  public static CALENDAR_EVENT_ENTITY_KEY = 'CalendarEvent';
  public static CALENDAR_EVENT_STAGING_ENTITY_KEY = 'CalendarEventStaging';
  public static CALENDAR_EVENT_COMMENT_DEFAULT_LANG = environment.calendar_event_comment_default_lang;
  public static CALENDAR_FULL_DAY_EVENT_FIELD = {
    type: "boolean",
    disabled: false,
    show_in_table: true,
    show_in_store: true,
    show_in_update: true,
    key: "full_day_event",
    triggerEventOnClick: true,
    label: "Full day event",
    rules: [
        "boolean",
        "nullable"
    ]
  }
  public static CALENDAR_EVENT_TYPE_BOTH_KEY = 'Both'
  public static CALENDAR_EVENT_AUTO_TRANSLATE_MESSAGE = "If a comment is added in Swedish or Norwegian, an English translation will be automatically created and saved."
  public static CALENDAR_RECURRING_EVENT_FIELD = {
    type: "enum",
    disabled: false,
    show_in_table: false,
    show_in_store: true,
    show_in_update: true,
    key: "recurring_event",
    label: "Recurring event",
    prefill: "",
    rules: [],
    values: [
        { value: "", label: "Does not repeat" },
        { value: "weekly", label: "Weekly" },
        { value: "monthly", label: "Monthly" },
        { value: "quarterly", label: "Quarterly" },
        { value: "yearly", label: "Yearly" }
    ]
  }
  public static CALENDAR_EVENT_MAX_RECURRING_COUNT = {
    weekly: 52,
    monthly: 24,
    quarterly: 10,
    yearly: 5
  } 
  public static KEYS_TO_DELETE_FROM_PAYLOAD = [
    'recurring_event', 'occurrences', 'full_day_event', 
    'is_selected', 'is_edited', 'is_child_edited', 
    'updated_at', 'revised_at', 'calendar_event_type', 
    'date_approximation', 'time_approximation', 'language', 
    'direkt_profile', 'owner', 'company_id', 'adjusted'
  ]
  public static LANGUAGE_ID_REQUIRED_ERROR_MESSAGE = 'The language is required when comment is present' 
  public static CALENDAR_EVENT_CREATE_PERMISSION_ERROR = "You don't have permission to create events in this tier."
  public static REPORT_DATES_CALENDAR_EVENT_TYPE = 'Earnings'
  public static REPORT_DATES_DIREKT_PROFILE_ID = environment.report_dates_default_profile_id
  public static REPORT_DATES_TIME_APPROXIMATION_ID = environment.report_dates_time_approximation_id
  public static REPORT_DATES_DEFAULT_TIMEZONE = 'Europe/Stockholm'
  public static REPORT_DATES_OWNER_TYPE = 'Company'
  public static EARNINGS_EVENT_FILTER_THRESHOLD = 14 //in months
  public static INSTITUTION_OWNER_CALENDAR_EVENT_DEFAULTS = environment.institution_calendar_event_defaults
  public static INSTITUTION_CALENDAR_EVENT_DEFAULTS_CONFIG: CalendarDefaultConfigItem[] = [
    { relationName: 'calendarEventType', foreignKey: 'calendar_event_type_id', value: CalendarEventSettings.INSTITUTION_OWNER_CALENDAR_EVENT_DEFAULTS.calendar_event_type },
    { relationName: 'timeApproximation', foreignKey: 'time_approximation_id', value: CalendarEventSettings.INSTITUTION_OWNER_CALENDAR_EVENT_DEFAULTS.time_approximation },
    { relationName: 'direktProfile', foreignKey: 'profile_id', value: CalendarEventSettings.INSTITUTION_OWNER_CALENDAR_EVENT_DEFAULTS.direkt_profile }
  ]
  public static COMPANY_CALENDAR_EVENT_DEFAULTS_CONFIG: CalendarDefaultConfigItem[] = [
    { relationName: 'dateApproximation', foreignKey: 'date_approximation_id', value: environment.date_approx_object },
    { relationName: 'timeApproximation', foreignKey: 'time_approximation_id', value: environment.time_approx_object }
  ]
}

export class featureFlagSettings{
  public static BASE_URL: string = ApiSettings.BASE_URL + '/feature_flag';
  public static FEATURE_KEYS = {
    'estimates_manual_onboarding': 'estimates-manual-onboarding',
  }
}

export class TelegramSettings {
  public static TELEGRAM_ENTITY_KEY = 'Telegram';
  public static SNAPSHOT_ENTITY_KEY = 'TelegramSnapshot';
  public static TEMPLATE_VARIABLE_EMPTY_VALUE = 'N/A';
  public static TELEGRAM_DEFAULT_TEMPLATES = [
    {
      content: `<p><span class="mention" data-index="0" data-denotation-char="@" data-id="company.name" data-value="Company name"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Company name</span></span></span></span>:&nbsp;<span class="mention mention-missing" data-index="0" data-denotation-char="@" data-id="operating_profit.name" data-value="Operating profit: name" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: name</span></span></span></span>&nbsp;<span class="mention mention-missing" data-index="1" data-denotation-char="@" data-id="operating_profit.mean" data-value="Operating profit: mean" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: mean</span></span></span></span>&nbsp;MLN&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="survey.currency" data-value="Currency"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Currency</span></span></span></span>&nbsp;VÄNTAS&nbsp;1&nbsp;KV–&nbsp;INFRONT&nbsp;(OMS)</p><p>(Omsändning:&nbsp;sändes&nbsp;första&nbsp;gången&nbsp;den&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="consensus.oldest_estimate_date" data-value="Oldest estimate date"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Oldest estimate date</span></span></span></span>)</p><p></p><p><span class="mention" data-index="0" data-denotation-char="@" data-id="estimates.html_table" data-value="Estimates table"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Estimates table</span></span></span></span>&nbsp;</p><p></p><p>Tabellen&nbsp;är&nbsp;ett&nbsp;utdrag&nbsp;från&nbsp;Infronts&nbsp;konsensustjänster.&nbsp;För&nbsp;att&nbsp;få&nbsp;tillgång&nbsp;till&nbsp;dessa,&nbsp;vänligen&nbsp;kontakta&nbsp;Michel&nbsp;Gafgo,&nbsp;Sales&nbsp;&nbsp;Director,&nbsp;på&nbsp;telefon&nbsp;+46&nbsp;8&nbsp;700&nbsp;56&nbsp;46&nbsp;eller&nbsp;+46&nbsp;704&nbsp;04&nbsp;0504&nbsp;alternativt&nbsp;e-post:&nbsp;michel.gafgo@infront.co.</p><p>STOCKHOLM&nbsp;(Nyhetsbyrån&nbsp;Direkt)&nbsp;Volvo&nbsp;väntas&nbsp;presentera&nbsp;ett&nbsp;rörelseresultat&nbsp;på&nbsp;<span class="mention mention-missing" data-index="1" data-denotation-char="@" data-id="operating_profit.mean" data-value="Operating profit: mean" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: mean</span></span></span></span>&nbsp;miljoner&nbsp;kronor&nbsp;för&nbsp;räkenskapsårets&nbsp;första&nbsp;kvartal&nbsp;enligt&nbsp;en&nbsp;sammanställning&nbsp;av&nbsp;19&nbsp;analytikers&nbsp;prognoser&nbsp;som&nbsp;Infront&nbsp;gjort.&nbsp;Det&nbsp;kan&nbsp;jämföras&nbsp;med&nbsp;17.109&nbsp;miljoner&nbsp;kronor&nbsp;motsvarande&nbsp;kvartal&nbsp;året&nbsp;innan.</p><p>Prognoserna&nbsp;från&nbsp;och&nbsp;med&nbsp;rörelseresultatet&nbsp;inkluderar&nbsp;jämförelsestörande&nbsp;poster&nbsp;om&nbsp;i&nbsp;genomsnitt&nbsp;-6,6&nbsp;miljoner&nbsp;kronor.</p><p>Av&nbsp;de&nbsp;analytiker&nbsp;som&nbsp;deltagit&nbsp;i&nbsp;Infronts&nbsp;sammanställning&nbsp;har&nbsp;tio&nbsp;stycken&nbsp;rekommendationen&nbsp;köp&nbsp;eller&nbsp;öka&nbsp;för&nbsp;aktien,&nbsp;medan&nbsp;nio&nbsp;har&nbsp;behåll&nbsp;eller&nbsp;avvakta.</p><p>Rapporten&nbsp;väntas&nbsp;den&nbsp;17&nbsp;april&nbsp;klockan&nbsp;7.20.</p><p>Deltagare:&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="survey.contributors" data-value="Contributors"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Contributors</span></span></span></span>&nbsp;</p>`,
      language_id: environment.telegram_languages[0].id,
    },
    {
      content: `<p><span class="mention" data-index="0" data-denotation-char="@" data-id="company.name" data-value="Company name"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Company name</span></span></span></span>:&nbsp;<span class="mention mention-missing" data-index="0" data-denotation-char="@" data-id="operating_profit.name" data-value="Operating profit: name" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: name</span></span></span></span>&nbsp;<span class="mention mention-missing" data-index="1" data-denotation-char="@" data-id="operating_profit.mean" data-value="Operating profit: mean" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: mean</span></span></span></span>&nbsp;MLN&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="survey.currency" data-value="Currency"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Currency</span></span></span></span>&nbsp;EXPECTED&nbsp;1&nbsp;KV–&nbsp;INFRONT&nbsp;(OMS)</p><p>(Rebroadcast:&nbsp;first&nbsp;broadcast&nbsp;on&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="consensus.oldest_estimate_date" data-value="Oldest estimate date"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Oldest estimate date</span></span></span></span>)</p><p></p><p><span class="mention" data-index="0" data-denotation-char="@" data-id="estimates.html_table" data-value="Estimates table"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Estimates table</span></span></span></span>&nbsp;</p><p></p><p>The&nbsp;table&nbsp;is&nbsp;an&nbsp;excerpt&nbsp;from&nbsp;Infront&#39;s&nbsp;consensus&nbsp;services.&nbsp;To&nbsp;access&nbsp;these,&nbsp;please&nbsp;contact&nbsp;Michel&nbsp;Gafgo,&nbsp;Sales&nbsp;Director,&nbsp;by&nbsp;phone&nbsp;+46&nbsp;8&nbsp;700&nbsp;56&nbsp;46&nbsp;or&nbsp;+46&nbsp;704&nbsp;04&nbsp;0504&nbsp;or&nbsp;email:&nbsp;michel.gafgo@infront.co.</p><p>&nbsp;STOCKHOLM&nbsp;(News&nbsp;Agency&nbsp;Direkt)&nbsp;Volvo&nbsp;is&nbsp;expected&nbsp;to&nbsp;report&nbsp;an&nbsp;operating&nbsp;profit&nbsp;of&nbsp;SEK&nbsp;<span class="mention mention-missing" data-index="1" data-denotation-char="@" data-id="operating_profit.mean" data-value="Operating profit: mean" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: mean</span></span></span></span>&nbsp;million&nbsp;for&nbsp;the&nbsp;first&nbsp;quarter&nbsp;of&nbsp;the&nbsp;financial&nbsp;year,&nbsp;according&nbsp;to&nbsp;a&nbsp;compilation&nbsp;of&nbsp;19&nbsp;analysts&#39;&nbsp;forecasts&nbsp;made&nbsp;by&nbsp;Infront.&nbsp;This&nbsp;compares&nbsp;with&nbsp;SEK&nbsp;17,109&nbsp;million&nbsp;in&nbsp;the&nbsp;corresponding&nbsp;quarter&nbsp;the&nbsp;year&nbsp;before.</p><p>&nbsp;The&nbsp;forecasts&nbsp;from&nbsp;the&nbsp;operating&nbsp;profit&nbsp;onwards&nbsp;include&nbsp;items&nbsp;affecting&nbsp;comparability&nbsp;of&nbsp;an&nbsp;average&nbsp;of&nbsp;SEK&nbsp;-6.6&nbsp;million.</p><p>&nbsp;Of&nbsp;the&nbsp;analysts&nbsp;who&nbsp;participated&nbsp;in&nbsp;Infront&#39;s&nbsp;compilation,&nbsp;ten&nbsp;have&nbsp;a&nbsp;buy&nbsp;or&nbsp;increase&nbsp;recommendation&nbsp;for&nbsp;the&nbsp;stock,&nbsp;while&nbsp;nine&nbsp;have&nbsp;a&nbsp;hold&nbsp;or&nbsp;wait&nbsp;recommendation.</p><p>&nbsp;The&nbsp;report&nbsp;is&nbsp;expected&nbsp;on&nbsp;April&nbsp;17&nbsp;at&nbsp;7:20&nbsp;a.m.</p><p>Contributors:&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="survey.contributors" data-value="Contributors"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Contributors</span></span></span></span>&nbsp;</p><p><span style="color: rgb(62, 108, 134);">Stock&nbsp;Exchange&nbsp;Editorial&nbsp;Office&nbsp;+46&nbsp;8&nbsp;51917911&nbsp;</span></p><p><span style="color: rgb(62, 108, 134);">https://twitter.com/Borsredaktion</span></p><p><span style="color: rgb(62, 108, 134);">News&nbsp;Agency&nbsp;Direct</span></p>`,
      language_id: environment.telegram_languages[1].id,
    },
    {
      content: `<p><span class="mention" data-index="0" data-denotation-char="@" data-id="company.name" data-value="Company name"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Company name</span></span></span></span>:&nbsp;<span class="mention mention-missing" data-index="0" data-denotation-char="@" data-id="operating_profit.name" data-value="Operating profit: name" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char"> @</span><span class="ql-mention-value">Operating profit: name</span></span></span></span>&nbsp;<span class="mention mention-missing" data-index="1" data-denotation-char="@" data-id="operating_profit.mean" data-value="Operating profit: mean" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: mean</span></span></span></span>&nbsp;millioner&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="survey.currency" data-value="Currency"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Currency</span></span></span>&nbsp;FORVENTET&nbsp;1&nbsp;KV&nbsp;–&nbsp;INFRONT&nbsp;(OMS)</p><p>(Reprisesending:&nbsp;første&nbsp;sending&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="consensus.oldest_estimate_date" data-value="Oldest estimate date"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Oldest estimate date</span></span></span></span>)</p><p></p><p><span class="mention" data-index="0" data-denotation-char="@" data-id="estimates.html_table" data-value="Estimates table"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Estimates table</span></span></span></span>&nbsp;</p><p></p><p>Tabellen&nbsp;er&nbsp;et&nbsp;utdrag&nbsp;fra&nbsp;Infronts&nbsp;konsensustjenester.&nbsp;For&nbsp;å&nbsp;få&nbsp;tilgang&nbsp;til&nbsp;disse,&nbsp;vennligst&nbsp;kontakt&nbsp;Michel&nbsp;Gafgo,&nbsp;salgsdirektør,&nbsp;på&nbsp;telefon&nbsp;+46&nbsp;8&nbsp;700&nbsp;56&nbsp;46&nbsp;eller&nbsp;+46&nbsp;704&nbsp;04&nbsp;0504&nbsp;eller&nbsp;e-post:&nbsp;michel.gafgo@infront.co.</p><p>STOCKHOLM&nbsp;(Nyhetsbyrået&nbsp;Direkt)&nbsp;Volvo&nbsp;forventes&nbsp;å&nbsp;rapportere&nbsp;et&nbsp;driftsresultat&nbsp;på&nbsp;<span class="mention mention-missing" data-index="2" data-denotation-char="@" data-id="operating_profit.mean" data-value="Operating profit: mean" title="Variable not found"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Operating profit: mean</span></span></span></span>&nbsp;millioner&nbsp;svenske&nbsp;kroner&nbsp;for&nbsp;første&nbsp;kvartal&nbsp;av&nbsp;regnskapsåret,&nbsp;ifølge&nbsp;en&nbsp;sammenstilling&nbsp;av&nbsp;19&nbsp;analytikeres&nbsp;prognoser&nbsp;laget&nbsp;av&nbsp;Infront.&nbsp;Dette&nbsp;til&nbsp;sammenligning&nbsp;med&nbsp;17&nbsp;109&nbsp;millioner&nbsp;svenske&nbsp;kroner&nbsp;i&nbsp;tilsvarende&nbsp;kvartal&nbsp;året&nbsp;før.</p><p>Prognosene&nbsp;fra&nbsp;driftsresultatet&nbsp;og&nbsp;utover&nbsp;inkluderer&nbsp;poster&nbsp;som&nbsp;påvirker&nbsp;sammenligningsevnen&nbsp;på&nbsp;i&nbsp;gjennomsnitt&nbsp;-6,6&nbsp;millioner&nbsp;SEK.</p><p>Av&nbsp;analytikerne&nbsp;som&nbsp;deltok&nbsp;i&nbsp;Infronts&nbsp;sammenstilling,&nbsp;har&nbsp;ti&nbsp;en&nbsp;kjøps-&nbsp;eller&nbsp;økningsanbefaling&nbsp;for&nbsp;aksjen,&nbsp;mens&nbsp;ni&nbsp;har&nbsp;en&nbsp;hold-&nbsp;eller&nbsp;vent-anbefaling.</p><p>Rapporten&nbsp;er&nbsp;ventet&nbsp;17.&nbsp;april&nbsp;klokken&nbsp;07:20.</p><p>Deltakere:&nbsp;<span class="mention" data-index="0" data-denotation-char="@" data-id="survey.contributors" data-value="Contributors"><span contenteditable="false"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">Contributors</span></span></span></span>&nbsp;</p>`,
      language_id: environment.telegram_languages[2].id,
    }
  ];
  public static TELEGRAM_LANGUAGES = environment.telegram_languages;
  public static MILLION_QUANTITY_ID = environment.telegram_custom_configs.million_quantity_id;
  public static PERCENT_UNIT_ID = environment.telegram_custom_configs.percent_unit_id;
  public static TWO_DECIMAL_POINT_MODULES = ['EPS', 'DPS'];
}

export class NewsDeskTierSettings {
  public static COMPANY_NEWS_DESK_TIER_ID = environment.company_news_desk_tier;
  public static INSTITUTION_NEWS_DESK_TIER_ID = environment.institution_news_desk_tier;
  public static JOURNALIST_ROLE = 'news-desk-journalist';
  public static SUPERUSER_ROLE = 'news-desk-superuser';
}